let User = function ($http, SERVER_URL) {
  "ngInject";

  return {
    getList: getList
  }

  function getList(page, limit) {
    if(!page){
      page = 0;
    }
    if(!limit){
      limit = 25;
    }
    return $http.get(`${SERVER_URL}/users/mobile?page=${page}&size=${limit}`)
  }
}
export default User;



// WEBPACK FOOTER //
// ./client/app/services/userService/user.service.js